import { SPopover } from './Popover.styles';
import { PopoverProps } from './Popover.types';

export const Popover = ({ ...props }: PopoverProps) => {
  return <SPopover {...props} />;
};
